import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../ui/Button";
import AboutCard from "../ui/AboutCard";
import PopupForm from "../ui/PopupForm";
import "../ui/about.css";

const AboutSection = () => {
  const contentRef = useRef(null);
  const location = useLocation();
  const { t } = useTranslation();
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    const scrollToSection = () => {
      if (location.hash) {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    };
    scrollToSection();
  }, [location]);

  const handlePopupOpen = () => {
    setIsPopupOpen(true);
  };

  const handlePopupClose = () => {
    setIsPopupOpen(false);
  };

  return (
    <>
      <section
        id="about"
        ref={contentRef}
        className="relative bg-cover bg-top flex flex-col justify-center items-center h-fit"
        style={{
          backgroundImage: `url(/img/lepenec_bg_main.webp)`,
          clipPath: "polygon(0 10%, 100% 0%, 100% 90%, 0 100%)",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-green-950/70 to-green-950/80"></div>

        <div className="relative z-10 max-w-[90%] xs:max-w-[85%] mx-auto mt-[-20px] xxs:pt-[290px] xxs:pb-[290px] xs:pt-[250px] xs:pb-[255px] sm:pt-[176px] sm:pb-[176px] xl:pt-[120px] xl:pb-[120px]">
          <div className="text-center mb-8 sm:mb-14">
            <h2 className="text-3xl xs:text-4xl sm:text-4xl md:text-4xl lg:text-4xl xl:text-5xl font-bold text-white leading-snug">
              {t("about.about_us")}
            </h2>
          </div>

          <p className="text-lg xs:text-xl sm:text-xl md:text-xl lg:text-xl text-white text-center leading-relaxed mx-auto mb-2 font-bold">
            {t("about.welcome_message_1")}
          </p>

          <p className="text-md xs:text-lg sm:text-sm md:text-lg lg:text-lg text-white text-center leading-relaxed mx-auto mb-6">
            {t("about.welcome_message_2")}
          </p>

          <div className="text-center">
            <Button onClick={handlePopupOpen}>{t("about.view_more")}</Button>
          </div>

          {/* Cards Section */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-6 sm:gap-16 md:gap-24 mx-4 mt-8">
            <AboutCard
              logo={t("cards.card4.title")}
              description1={t("cards.card4.description1")}
              description2={t("cards.card4.description3")}
              imageSrc="/img/hani-i-elezit.png"
              link="https://kk.rks-gov.net/haniielezit/"
            />
            <AboutCard
              logo={t("cards.card2.title")}
              description1={t("cards.card2.description1")}
              description2={t("cards.card2.description2")}
              imageSrc="/img/dzs.png"
              link="https://www.dzs.gov.mk/"
            />
            <AboutCard
              logo={t("cards.card3.title")}
              description1={t("cards.card3.description1")}
              description2={t("cards.card3.description3")}
              imageSrc="/img/logo2.png"
              link="https://www.mit-ks.net/en/"
            />
            <AboutCard
              logo={t("cards.card1.title")}
              description1={t("cards.card1.description1")}
              description2={t("cards.card1.description2")}
              imageSrc="/img/2idrja.png"
              link="https://www.linkedin.com/company/2idrja/posts/?feedView=all"
            />
          </div>
        </div>
      </section>

      {/* Use PopupForm Component */}
      <PopupForm isOpen={isPopupOpen} onClose={handlePopupClose}>
        <h3 className="text-3xl font-bold mb-4 text-center">
          {t("about.discover_more")}
        </h3>
        <p className="text-lg font-bold mb-4 text-center">
          {t("about.welcome_message_1")}
        </p>
        <p className="text-lg mb-4 text-justify">
          {t("about.welcome_message_2")}
        </p>
        <p className="text-lg mb-4 text-justify">
          {t("about.project_description_1")}
        </p>
        <p className="text-lg mb-4 text-justify">
          {t("about.project_description_2")}
        </p>
        <p className="text-lg mb-4 text-justify">
          {t("about.bulleted_list_title")}
        </p>
        <ul className="list-disc pl-6 mb-4 text-justify">
          <li>{t("about.bulleted_list_1")}</li>
          <li>{t("about.bulleted_list_2")}</li>
          <li>{t("about.bulleted_list_3")}</li>
        </ul>
        <p className="text-lg mb-4 text-justify">
          {t("about.project_description_3")}
        </p>
        <p className="text-lg font-bold mb-4 text-center">
          {t("about.project_description_4")}
        </p>
      </PopupForm>
    </>
  );
};

export default AboutSection;
